import React, { useState, useRef, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import gfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';

interface HomeBannerTextProps {
    bannerText: string,
    lang: string,
    currentSlide: number
}

const BusinessBannerText: React.FC<HomeBannerTextProps> = ({ bannerText, lang, currentSlide }) => {
  const [isExpandedContent, setIsExpandedContent] = useState(false);
  const [showToggleContent, setShowToggleContent] = useState(false);
  const [title, setTitle] = useState<string>('');
  const [content, setContent] = useState<string>('');
  const contentRef = useRef(null);

  useEffect(()=>{
      setIsExpandedContent(false);
  },[currentSlide])

  useEffect(() => {
    const headingRegex = /<(h[1-6])[^>]*>[\s\S]*?<\/\1>/g;
    const contentRegex = /<(p)[^>]*>[\s\S]*?<\/\1>/g;

    const headings: string[] = bannerText.match(headingRegex) || [];
    const contentTags: string[] = bannerText.match(contentRegex) || [];

    setTitle(headings.join(''));

    const contentText = contentTags.reduce((prev, curr) => prev + curr, "");
    setContent(contentText.replaceAll("</p><p>", "<c>"));
  }, [bannerText]);

  useEffect(() => {
    if (!contentRef.current) return;
    const contentElement = contentRef.current.querySelector('p');
    const clientHeight = contentElement?.clientHeight;
    const contentHeight = contentElement?.scrollHeight;
    setShowToggleContent(contentHeight > clientHeight);

    return () => setShowToggleContent(false);
  }, [bannerText,contentRef.current]);

  const handleToggle = () => {
    setIsExpandedContent(prev => !prev);
  }

  return (
    <div className="banner-container">
      <div className='banner-text-field mb-1' >
          <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]} components={{
            h1: ({ node, ...props }) => (
              <h1 className="banner-title" {...props} />
            ),
            h2: ({ node, ...props }) => (
              <h2 className="banner-title" {...props} />
            ),
            h3: ({ node, ...props }) => (
              <h3 className="banner-title" {...props} />
            ),
            h4: ({ node, ...props }) => (
              <h4 className="banner-title" {...props} />
            ),
            h5: ({ node, ...props }) => (
              <h5 className="banner-title" {...props} />
            ),
            h6: ({ node, ...props }) => (
              <h6 className="banner-title" {...props} />
            ),
          }}>{title}</ReactMarkdown>
        <div className={`banner-content ${isExpandedContent ? 'expanded' : 'collapsed'}`} ref={contentRef}>
          <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{content}</ReactMarkdown>
        </div>
      </div>
      { showToggleContent && (
        <a
          href='javascript:void(0);'
          onClick={handleToggle}
          className="showmore-homepage color-1 barlow-font"
        >
        {isExpandedContent ? (lang=="en" ? 'See Less' : '隱藏') : (lang=="en" ? 'See More' : '更多')}
        </a>
      )}


      <style>{`
        c{
          display: block;
          margin-top: 18px;
        }
        .banner-container {
          width: 100%;
          overflow: hidden;
        }
        .collapsed p{
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        .banner-title {
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          color:inherit;
        }
        h2.banner-title {
          font-size: 36px !important;
          margin-bottom: 10px;
        }

        .showmore-homepage{
          color: #ef9528 !important;
          text-decoration: none;
        }
        .showmore-homepage:hover{
          font-weight: 500;
        }

      `}</style>
    </div>
  );
};

export default BusinessBannerText;